import React, { useState } from "react";
import { Col, Row } from "reactstrap";
import { Input } from "@chakra-ui/react";
import { showSapCodeField } from "../../../constants/helpers/product";

const ProductDataSKU = ({ product, changeHandler }) => {
  const [dataSKU, setDataSKU] = useState({
    sku: product.sku ? product.sku : "",
    barcode: product.barcode ? product.barcode : "",
    odooCode: product.odooCode ? product.odooCode : "",
    sapCode: product.sapCode ? product.sapCode : "",
  });
  const dataSkuHandler = (e) => {
    const temp = { ...dataSKU };
    temp[e.target.name] = e.target.value;
    setDataSKU(temp);
    changeHandler(e);
  };
  return (
    <Row style={{ padding: "16px" }}>
      <Col xl={6} style={{ marginBottom: "8px" }}>
        <p
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            marginBottom: "8px",
            color: "black",
          }}
        >
          No SKU
        </p>
        <Input
          placeholder="No SKU"
          name="sku"
          onChange={(e) => dataSkuHandler(e)}
          value={dataSKU.sku}
        />
      </Col>
      <Col xl={6} style={{ marginBottom: "8px" }}>
        <p
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            marginBottom: "8px",
            color: "black",
          }}
        >
          Barcode
        </p>
        <Input
          placeholder="Barcode"
          name="barcode"
          onChange={(e) => dataSkuHandler(e)}
          value={dataSKU.barcode}
        />
      </Col>
      <Col xl={6} style={{ marginBottom: "8px" }}>
        <p
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            marginBottom: "8px",
            color: "black",
          }}
        >
          Odoo Code
        </p>
        <Input
          placeholder="Odoo Code"
          name="odooCode"
          onChange={(e) => dataSkuHandler(e)}
          value={dataSKU.odooCode}
        />
      </Col>
      {showSapCodeField && (
        <Col xl={6} style={{ marginBottom: "8px" }}>
          <p
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              marginBottom: "8px",
              color: "black",
            }}
          >
            SAP Code
          </p>
          <Input
            placeholder="SAP Code"
            name="sapCode"
            onChange={(e) => dataSkuHandler(e)}
            value={dataSKU.sapCode}
          />
        </Col>
      )}
    </Row>
  );
};

export default ProductDataSKU;
